import apiRequest from "../api/apiRequest";
import { cachedAPIWrapper, getCachedAPIResponse } from "../apiCaching/apiWrapper";
import { bookingUsPostCallWrapper } from "../apiCaching/POST-Requests/apibookingCallWrapper";
import { contactUsPostCallWrapper } from "../apiCaching/POST-Requests/apiContactCallWrapper";
import { BookingPayloadModel } from "../apiCaching/POST-Requests/interface/booking/bookingInterface";
import { ContactUsPayloadModel } from "../apiCaching/POST-Requests/interface/contact/contactInterface";
import { apiConfig } from "../config/apiConfig";
import { handleMissingData } from "../util/discovery";
import { getSessionAndCorrelationID } from "../util/getSessionCorrelationId";
import { startLoader, stopLoader } from "../util/loader";
import { constructAppointMentApiUrl, getBrandDetailsFromBrandJson, getConceptId, storeBookingApiPayload } from "../util/share";
import { isTestFcn } from "./booking-payload";
import { validEstimate } from "./confirmation";
import { throwBookingError } from "./molly-flow";
import { isTouchDevice } from "../util/device-detection";
import { closeFunctionality } from "../util/createModal";
import { apiCaching } from "../config/cachingConfig";
import { FullAttributeParams } from "../apiCaching/GET-Requests/interface/fullattribute/fullattributeInterface";
import { TechAvailabilityParams } from "../apiCaching/GET-Requests/interface/techAvaliblity/techAvaliblityInterface";
import { MollyEstimate } from "./interfaces/mollyEstimate";
let moment = require('moment');
const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
const conceptId = (document.getElementById('conceptId') as HTMLInputElement)?.value;

export function noCalendarPricing():string{
    const priceNote = sessionStorage.getItem("PriceNote");
    if(priceNote?.includes("No Calendar Pricing")){
        return "No Calendar Pricing";
    }
    return '';
}

export function getWeekendEstimate(estimateData:MollyEstimate, isMIMO:boolean): { low: number, high: number }{
    let lowValue:number;
    let highValue:number;
    if(isMIMO){
        lowValue = Math.round(estimateData?.estimateMoveRangeLowSaturday);
        highValue = Math.round(estimateData?.estimateMoveRangeHighSaturday);
    }else{
        lowValue = Math.round(estimateData?.estimateOccasionalRangeLowSaturday);
        highValue = Math.round(estimateData?.estimateOccasionalRangeHighSaturday);
    }
    return {
        low: lowValue || 0,
        high: highValue || 0
    }
}

export function getRegularEstimate(estimateData:MollyEstimate, isMIMO:boolean): { low: number, high: number }{
    let lowValue:number;
    let highValue:number;
    if(isMIMO){
        lowValue = Math.round(estimateData?.estimateMoveRangeLow);
        highValue = Math.round(estimateData?.estimateMoveRangeHigh);
    }else{
        lowValue = Math.round(estimateData?.estimateOccasionalRangeLow);
        highValue = Math.round(estimateData?.estimateOccasionalRangeHigh);
    }
    return {
        low: lowValue || 0,
        high: highValue || 0
    }
}

function appendPriceNotes(bookingPayload:any){
    
    const otcEstimateTrue = bookingPayload.customerType?.toLowerCase().includes("residential") && !bookingPayload.jobFrequency.toLowerCase().includes("recurring") && validEstimate();
    const noCalendarPricingFlag = noCalendarPricing();
    if(otcEstimateTrue){
        const estimateData = JSON.parse(sessionStorage.getItem("mollyEstimate") as string);
        const oneTimeClean = bookingPayload.jobFrequencyDetail.toLowerCase().includes("not a move in or move out clean");
        const dateDay = sessionStorage.getItem('selectedDay');
        const isWeekend = (dateDay ==='Saturday' || dateDay === 'Sunday');
        let estimateText: { low: number, high: number };
        if(isWeekend){
            estimateText = getWeekendEstimate(estimateData, !oneTimeClean);
        }
        else{
            estimateText = getRegularEstimate(estimateData, !oneTimeClean);
        }
        if(estimateText.low>0 && estimateText.high>0){
            const priceNote = `Price: $${estimateText.low} - $${estimateText.high} ${noCalendarPricingFlag}`;
            sessionStorage.setItem("PriceNote", priceNote);
        }
    }
}

export function payloadHelper(bookingPayload:BookingPayloadModel){
    bookingPayload.note = '';  // Reset payload note to avoid duplication
    const outStr = sessionStorage.getItem("PriceNote");
    const outStr2 = sessionStorage.getItem("noZipNote");
    let noteText = '';
    const isResidentialOTC = bookingPayload.customerType?.toLowerCase().includes("residential") && !bookingPayload.jobFrequency?.toLowerCase().includes("recurring");
    if(outStr && isResidentialOTC){
        noteText = noteText.concat(outStr + ', ');
    }
    if(outStr2){
        noteText = noteText.concat(outStr2 + ', ');
    }
    noteText = noteText.concat(`Customer Type: ${bookingPayload.customerType}, MLY Frequency: ${bookingPayload.jobFrequency}`);
    if(bookingPayload?.jobFrequency?.toLowerCase().includes("one-time")){
        noteText = noteText.concat(`, ${bookingPayload.jobFrequencyDetail}`);
    }
    if (bookingPayload.estimateSquareFeet && bookingPayload.estimateBathrooms) {
        const squareFeet = bookingPayload.estimateSquareFeet;
        const bedroomsOrOffices = bookingPayload.estimateBedrooms;
        const bathrooms = bookingPayload.estimateBathrooms;
        const isResidential = bookingPayload.customerType?.toLowerCase().includes("residential");
        const bedroomsLabel = isResidential ? "Bedrooms" : "Offices";
        noteText = noteText.concat(
            `, Square Feet: {${squareFeet}}, ${bedroomsLabel}: {${bedroomsOrOffices}} , Bathrooms: {${bathrooms}}`
        );
    }
    const preference = sessionStorage.getItem('PreferredCommunicationText') as string;
    if (preference?.toLowerCase().includes("text")) {
        noteText = noteText.concat(`, Text OptIn: Yes`);
    }
    const callBackId = sessionStorage.getItem('callBackID');
    if (callBackId) {
        noteText = noteText.concat(' ,' + callBackId);
    }
    if(!bookingPayload.note.includes(noteText)){
        bookingPayload.note = bookingPayload.note.concat(noteText);
    }
    return bookingPayload;
}

export async function callBookingApi(bookingPayload: BookingPayloadModel, browerCloseCheck?: boolean){
    startLoader();
    sessionStorage.setItem('formValues', JSON.stringify(bookingPayload));
    appendPriceNotes(bookingPayload);
    bookingPayload = payloadHelper(bookingPayload);
    const brandData = await getBrandDetailsFromBrandJson(conceptCode);
    let pauseLeadFlag = brandData.pause_lead_flag;
    let sessionID: string | undefined;
    let correlationID: string | undefined;
    const sessionAndCorelation = getSessionAndCorrelationID();
    sessionID = sessionAndCorelation.sessionID;
    correlationID = sessionAndCorelation.correlationID;
    if(correlationID)
        bookingPayload.correlationId = correlationID;

    const out = await handleMissingData(bookingPayload.city, bookingPayload.state, bookingPayload.zipCode);
    bookingPayload.city = out?.city || bookingPayload.city;
    bookingPayload.state = out?.state || bookingPayload.state;

    let url = '';
    if(correlationID && sessionID){
        url = `${apiConfig.BOOKING_API_URL}&correlationId=${correlationID}&sessionId=${sessionID}`
    }
    else{
        url = apiConfig.BOOKING_API_URL;
    }
    
    if(browerCloseCheck){
        bookingPayload.note = bookingPayload?.note?.concat(" ID: 5ubm17 ");  // Append note for incomplete flow leads
    }

    const callFromCalendar = sessionStorage.getItem("callFromCalendar");
    if(callFromCalendar==="true"){
        // happy flow
        const isBookingDone = sessionStorage.getItem("isBookingDone");
        if(isBookingDone && isBookingDone==="true"){
            return;
        }
    }


    await bookingUsPostCallWrapper(url, bookingPayload)
    .then((response: any) => {
        sessionStorage.removeItem('callBackID');
            if(response){
                if(callFromCalendar==="true"){
                    sessionStorage.setItem("isBookingDone","true");
                }
                storeBookingApiPayload(bookingPayload, response);
                window.history.replaceState({}, "" , window.location.href);
                if(browerCloseCheck) {
                    sessionStorage.setItem('IsLeadOnly','false');
                    sessionStorage.setItem("bookingLeadSent", "true");
                    if (!pauseLeadFlag) {
                        stopLoader();
                        if (isTouchDevice()) {
                            closeFunctionality();
                        }
                    }
                } 
                if(!browerCloseCheck) {
                    document.querySelectorAll("form").forEach((f)=>{
                        f.reset();
                    });
                    window.location.pathname = '/confirmation';
                }
            }
            else{
                if(!pauseLeadFlag) {
                const flag = isTouchDevice() && browerCloseCheck ? closeFunctionality() : throwBookingError();
                }
                else {
                    throwBookingError();
                }
            }
            
        })
        .catch((error:any) => {
            if(!pauseLeadFlag) {
            const flag = isTouchDevice() && browerCloseCheck ? closeFunctionality() : errorHandlingForBookingApi(error);
            }
            else {
                errorHandlingForBookingApi(error);
            }
        })
}

export async function getFranchiseDetails(addressParam:string) : Promise<any> {
    const conceptID = getConceptId();  
    const url:any = apiConfig.LocateLocationApiWithRoundRobin+`/${addressParam}/false/true/${conceptID}`;
    const result:any = cachedAPIWrapper(url);
    return result;
}

export function determineFlowType(WebLocationId:number) : any {
    // Function to determine whether OS flow or Lead flow
    const url = `${apiConfig.GET_ATTRIBUTE_DATA}/${WebLocationId}`;
    return cachedAPIWrapper(url);
}

export function errorHandlingForBookingApi(error:any) {
    if (error?.message?.toLowerCase().includes("request throttled due to duplicate payload")) {
        redirectToConfirmationPage();
    } else {
        throwBookingError();
    }
}
function redirectToConfirmationPage() {
    document.querySelectorAll("form").forEach((f)=>{ f.reset(); });
    window.location.pathname = '/confirmation';
}

export async function checkTechAvailability(arg:string) : Promise<any> {
    const weblocationId = localStorage.getItem("franchiseWebLocationId");
    const zipValue = sessionStorage.getItem('zipcode');
    const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
    const brandData = await getBrandDetailsFromBrandJson(conceptCode);
    const maxWeeks = brandData?.calendarMaxWeeksCap ? brandData?.calendarMaxWeeksCap: 8;
    const vendorId = brandData?.vendorId;
    let estFlag;
    if(arg.toLowerCase().includes('recurring')){
        estFlag = true;
    }else{
        estFlag = false;
    }
 
    const techAvailabilityParams: TechAvailabilityParams = {
        PostalCode: zipValue ?? "",
        WebLocationId: weblocationId ?? "",
        DateStart: moment().format('MM/DD/YYYY'),
        IsEstimate: estFlag,
        apikey: process.env.JS_API_KEY,
        VendorId: vendorId,
        NumberOfDays: 7*maxWeeks
    };
    const dynamic_url = constructAppointMentApiUrl(techAvailabilityParams);
 
    return getCachedAPIResponse(dynamic_url,apiCaching.TechAvailability);
    
}

export async function configureMollyEstimate() : Promise<boolean>{
// This method will call an API to confirm whether the estimate needs to be shown in the calendar screen or not.
    let locationID = (localStorage.getItem("franchiseWebLocationId") ? localStorage.getItem("franchiseWebLocationId") : localStorage.getItem('weblocationId')) as FullAttributeParams;
    const val = await determineFlowType(Number(locationID));
    const returnVal = val?.options?.mollyOneTimeCleansDisableEstimatePricing;
    return !returnVal;
}

export async function confirmMlyLeadSourceAPI() : Promise<string>{
    const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
    let endpoint:string = apiConfig.GenericLeadSourceEndpoint;
    const brandData = await getBrandDetailsFromBrandJson(conceptCode);
    if(brandData){
        if(brandData?.send_brand_leadsource_api){
            endpoint = apiConfig.MollyLeadSourceEndpoint;
        }
        else{
            endpoint = apiConfig.GenericLeadSourceEndpoint;
        }
    }
    return endpoint;
    
}

export async function setDefaultLeadSource(): Promise<any> {
    const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
    const brandData = await getBrandDetailsFromBrandJson(conceptCode);
    const obj = {
        "LeadSourceID": brandData?.default_leadSourceID || 0,
        "LeadSource": brandData?.default_leadSource ?? 'Web'
    }
    return obj;
}

export async function calcEstimate(bookingPayload:any){
    startLoader();
    sessionStorage.removeItem("noCalendarPricing");
    let payload ={
        "franchiseWebLocationId": bookingPayload.webLocationId,
        "LeadSourceId": bookingPayload.leadSourceId,
        "FirstName": bookingPayload.firstName,
        "LastName": bookingPayload.lastName,
        "Address": bookingPayload.address + (bookingPayload.address2 ? `, ${bookingPayload.address2}` : ""),
        "City": bookingPayload.city,
        "State": bookingPayload.state,
        "PostalCode": bookingPayload.postalCode.trim(),
        "Email": bookingPayload.email,
        "Phone": bookingPayload.phone,
        "EstimateSquareFeet": Number(bookingPayload.estimateSquareFeet),
        "EstimateBedrooms": Number(bookingPayload.estimateBedrooms),
        "EstimateBathrooms": Number(bookingPayload.estimateBathrooms),
        "conceptId": conceptId,
        "vendorId": Number(bookingPayload.vendorId)
    } as { [key: string]: any };
    
    const request = {
        method: 'POST',
        url: apiConfig.calculateEstimate,
        data: payload
    };

    if(bookingPayload.firstName?.toLowerCase() === 'isfakesubmit' || bookingPayload.lastName?.toLowerCase() === 'isfakesubmit'){
        return new Promise((resolve) => {
            setTimeout(() => {
                stopLoader();
                console.warn('IsFakeSubmit Detected, skipping API call for calculate estimate');
                sessionStorage.setItem("noCalendarPricing","true");
                resolve(null);
            }, 1000);
        });
    }
   return apiRequest(request)
        .then((response: any) => {
            stopLoader();
            if(response){
                sessionStorage.setItem("mollyEstimate",JSON.stringify(response));
                return response;
            }
            else{
                console.warn('CalculateEstimate API call returned no response');
                sessionStorage.setItem("noCalendarPricing","true");
                return null;
            }
            
        })
        .catch((error:any) => {
            stopLoader();
            console.error('Error in CalculateEstimate API call:', error);
            sessionStorage.setItem("noCalendarPricing","true");
            return null;
        })
    
}

export function calcEstFail(){
    const varFlag = sessionStorage.getItem("noCalendarPricing");
    if(varFlag && varFlag=="true"){
        return true;
    }
    return false;
}

export async function contactUsEndpoint(bookingPayload:any){
    startLoader();
    const brandData = await getBrandDetailsFromBrandJson(conceptCode);
    let noZipText= brandData.osflow_contactUs_comments;
    const requestBody: ContactUsPayloadModel = {
        "firstName": bookingPayload.firstName,
        "lastName": bookingPayload.lastName ?? '',
        "zipCode": bookingPayload.zipCode,
        "phone": bookingPayload.phone,
        "email": bookingPayload.email,
        "city": bookingPayload.city, 
        "state": bookingPayload.state,
        "country": bookingPayload.country ?? '',
        "address": bookingPayload.address ?? '',
        "address2": bookingPayload.address2 ?? '',
        "comments": noZipText ?? "",
        "signUpForUpdates": true,
        "isLocalized": false,
        "isNewCustomer": "", 
        "isTest": isTestFcn(),
        "conceptId": Number(conceptId),
        "conceptCode": conceptCode,
        "vendorId": Number(brandData.vendorId)
    };
   
    return contactUsPostCallWrapper(apiConfig.CONTACT_US_SEND, requestBody)
        .then((response)=>{
            stopLoader();
            if(response){
                storeBookingApiPayload(requestBody,response);
                window.history.replaceState({}, "" , window.location.href);
                document.querySelectorAll("form").forEach((f)=>{
                    f.reset();
                });
                window.location.pathname = '/confirmation';
            }
            else{
                throwBookingError();
            }
        })
        .catch((err)=>{
            stopLoader();
            throwBookingError();
        });
}